import { AsyncPipe } from '@angular/common';
import {
	Component,
	OnInit,
	ChangeDetectionStrategy
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Observable } from 'rxjs';
import { VIEWS } from '@go-modules/enums/views';
import { ViewStateDataSource } from '@go-modules/services/view-state-datasource/view-state.datasource';

@Component({
	selector: 'toggle-grid-list-view',
	imports: [
		TranslateModule,
		MatIconModule,
		MatTooltipModule,
		AsyncPipe
	],
	templateUrl: './toggle-grid-list-view.component.html',
	styleUrls: ['./toggle-grid-list-view.component.scss'],
	changeDetection: ChangeDetectionStrategy.Default
})
export class ToggleGridListViewComponent implements OnInit {
	public currentView$: Observable<VIEWS>;
	public views = VIEWS;

	constructor (
		public viewStateDataSource: ViewStateDataSource
	) {}

	public ngOnInit (): void {
		this.currentView$ = this.viewStateDataSource.viewState$;
	}

}
